module.exports = __webpack_public_path__ + "static/media/close.06311299.svg";